<script>
  import tt from '@tomtom-international/web-sdk-maps'
  import TomServices from '@tomtom-international/web-sdk-services'

  export default {
    components: {},
    nome: 'documento',
    data () {
      return {
        api_key: 'MdpIjOOXGAuqUwtje2RgFCpZ7epTxGNV',
        isLoading: true,
        isLoaded: true,
        data: {
          adress: ''
        },
        // ***** Vargem grande ******
        // patio: {
        //   lat: '-23.00116',
        //   lng: '-43.50937'
        // },
        // ***** espirito santo *****
        patio: {
          lat: '-20.420874',
          lng: '-40.329344'
        },
        pointA: {
          lat: 0,
          lng: 0
        },
        pointB: {
          lat: 0,
          lng: 0
        },
        originTodestiny: {
          metros: 0,
          time: 0
        },
        destinyToorigin: {
          metros: 0,
          time: 0
        },
        tiposLocations: [
          {label: 'Pátio', value: 0, class: 'btn-default'}
          // {label: 'Localização Atual', value: 1, class: 'btn-primary'}
        ],
        current_tp_location: 0 // patio = 0
      }
    },
    mounted () {
      this.$loaderOverlay.open().message('Carregando...')
      this.map = tt.map({
        key: this.api_key,
        container: 'map',
        style: 'tomtom://vector/1/basic-main',
        dragPan: true
      })
      this.map.addControl(new tt.FullscreenControl())
      this.map.addControl(new tt.NavigationControl())
      document.querySelector('.mapboxgl-control-container').style.display = 'none'
      window.setTimeout(() => {
        this.$loaderOverlay.hide()
      }, 2000)
    },
    activated () {
    },
    destroyed () {
    },
    computed: {
      kmIda () {
        return this.originTodestiny.metros !== 0 ? (this.originTodestiny.metros / 1000).toFixed(1) + ' KM' : '-'
      },
      kmVolta () {
        return this.destinyToorigin.metros !== 0 ? (this.destinyToorigin.metros / 1000).toFixed(1) + ' KM' : '-'
      },
      kmTotal () {
        return this.originTodestiny.metros !== 0 && this.destinyToorigin.metros !== 0 ? ((this.originTodestiny.metros + this.originTodestiny.metros) / 1000).toFixed(1) + ' KM' : '-'
      },
      timeIda () {
        return this.originTodestiny.time !== 0 ? Math.round(this.originTodestiny.time / 60) + ' minutos' : '-'
      },
      timeVolta () {
        return this.destinyToorigin.time !== 0 ? Math.round(this.destinyToorigin.time / 60) + ' minutos' : '-'
      },
      timeTotal () {
        return this.originTodestiny.time !== 0 && this.destinyToorigin.time !== 0 ? Math.round((this.originTodestiny.time + this.destinyToorigin.time) / 60) + ' minutos' : '-'
      }
    },
    watch: {},
    methods: {
      submit () {
        var that = this.data
        this.$loaderOverlay.open().message('Buscando...')
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        TomServices.services.geocode({
          key: this.api_key,
          query: that.adress,
          countrySet: 'BRA'
        })
        .go()
        .then((response) => {
          console.log(response)
          this.pointB.lat = response.results[0].position.lat
          this.pointB.lng = response.results[0].position.lng
          this.currentPosition()
          this.getRoute()
        })
        .catch((err) => {
          this.$loaderOverlay.hide()
          console.error(err)
          alert('Erro na pesquisa do destino, tente novamente com mais detalhes!')
        })
      },
      getRoute () {
        var origin = this.pointA.lng + ',' + this.pointA.lat
        var destiny = this.pointB.lng + ',' + this.pointB.lat
        console.log(origin, destiny)
        if (this.map.getLayer('route')) {
          this.map.removeLayer('route')
          this.map.removeSource('route')
        }
        // origin to destiny
        TomServices.services.calculateRoute({
          key: this.api_key,
          traffic: true,
          vehicleAdrTunnelRestrictionCode: 'D',
          language: 'pt-BR',
          locations: origin + ':' + destiny
        })
        .go()
        .then((response) => {
          console.log('origin to destiny', response)
          this.originTodestiny.metros = response.routes[0].summary.lengthInMeters
          this.originTodestiny.time = response.routes[0].summary.travelTimeInSeconds
          var geojson = response.toGeoJson()
          this.drawMap(geojson)
        })
        .catch((error) => {
          console.log(error)
          this.$loaderOverlay.hide()
          alert('Error no calculo de rota, verifique o endereço pesquisado!')
        })
        // destiny to origin
        setTimeout(() => {
          TomServices.services.calculateRoute({
            key: this.api_key,
            traffic: true,
            ehicleAdrTunnelRestrictionCode: 'D',
            language: 'pt-BR',
            locations: destiny + ':' + origin
          })
          .go()
          .then((res) => {
            console.log('destiny to origin', res)
            this.destinyToorigin.metros = res.routes[0].summary.lengthInMeters
            this.destinyToorigin.time = res.routes[0].summary.travelTimeInSeconds
          })
          .then(() => {
            this.$loaderOverlay.hide()
          })
          .catch((error) => {
            console.log(error)
            this.$loaderOverlay.hide()
          })
        }, 1000)
      },
      createMarkerElement (type) {
        var element = document.createElement('div')
        var innerElement = document.createElement('div')

        element.className = 'route-marker'
        innerElement.className = 'icon this.tt-icon -white -' + type
        element.appendChild(innerElement)
        return element
      },
      addMarkers (feature) {
        var startPoint, endPoint
        if (feature.geometry.type === 'MultiLineString') {
          startPoint = feature.geometry.coordinates[0][0] // get first point from first line
          endPoint = feature.geometry.coordinates.slice(-1)[0].slice(-1)[0] // get last point from last line
        } else {
          startPoint = feature.geometry.coordinates[0]
          endPoint = feature.geometry.coordinates.slice(-1)[0]
        }
        new tt.Marker({ element: this.createMarkerElement('start') }).setLngLat(startPoint).addTo(this.map)
        new tt.Marker({ element: this.createMarkerElement('finish') }).setLngLat(endPoint).addTo(this.map)
      },
      findFirstBuildingLayerId () {
        var layers = this.map.getStyle().layers
        for (var index in layers) {
          if (layers[index].type === 'fill-extrusion') {
            return layers[index].id
          }
        }
        throw new Error('O estilo de mapa não contém nenhuma camada com tipo de extrusão de preenchimento.')
      },
      currentPosition () {
        if (this.current_tp_location === 0) {
          this.pointA.lat = this.patio.lat
          this.pointA.lng = this.patio.lng
        } else {
          navigator.geolocation.getCurrentPosition(pos => {
            this.gettingLocation = false
            this.patioA.lat = pos.coords.latitude
            this.patioA.lng = pos.coords.longitude
          }, err => {
            this.gettingLocation = false
            var msg = ''
            switch (err.code) {
              case err.code.PERMISSION_DENIED:
                msg = 'Permissão negada para acesso a Geolocalização.'
                break
              case err.code.POSITION_UNAVAILABLE:
                msg = 'Os dados de localização estão inválidos.'
                break
              case err.code.TIMEOUT:
                msg = 'Tempo de busca pela localização expirado.'
                break
              case err.code.UNKNOWN_ERROR:
                msg = 'Erro não reconhecido!Contacte o administrador'
                break
            }
            alert(msg)
            window.history.back()
            return null
          })
        }
      },
      drawMap (geojson) {
        this.map.addLayer({
          'id': 'route',
          'type': 'line',
          'source': {
            'type': 'geojson',
            'data': geojson
          },
          'paint': {
            'line-color': '#4a90e2',
            'line-width': 6
          }
        }, this.findFirstBuildingLayerId())
        this.addMarkers(geojson.features[0])
        var bounds = new tt.LngLatBounds()
        geojson.features[0].geometry.coordinates.forEach((point) => {
          bounds.extend(tt.LngLat.convert(point))
        })
        this.map.fitBounds(bounds, { duration: 0, padding: 50 })
      }
    }
  }
</script>
<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Solicitar Remoção</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'documentos'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <form @submit.prevent.stop="" class="bs-example form-horizontal">
              <div class="form-group">
                <label class="col-sm-1 control-label">Origem</label>
                 <div class="col-sm-3">
                   <u-button-group v-model="current_tp_location" :options="tiposLocations" class="pull-left m-r"></u-button-group>
                </div>
              </div>
              <div class="form-group">
               
                <label class="col-sm-1 control-label">Destino</label>
                <div class="col-sm-6">
                    <input type="text" class="form-control" placeholder="" name="adress" @keyup.enter="submit" v-model="data.adress" required>
                </div>
                <div class="col-sm-2">
                  <u-button class="btn m-b-xs w-xs m-r-xs btn-info btn-search" @click="submit">Pesquisar</u-button>
                </div>
              </div>
            </form>
            <div class="row wrapper-md"> 
              <div id="map" class="map"></div> 
            </div>
            <div class="row wrapper-md"> 
              <div class="col-sm-2 label-info">
                <span>Deslocamento Ida :</span>
              </div>
              <div class="col-sm-2">
                <span>{{kmIda}} / {{timeIda}}</span>
              </div>
              <div class="col-sm-2 label-info">
                <span>Deslocamento Volta :</span>
              </div>
              <div class="col-sm-2">
                <span>{{kmVolta}} / {{timeVolta}}</span>
              </div>
              <div class="col-sm-2 label-info">
                <span>Deslocamento Total :</span>
              </div>
              <div class="col-sm-2">
                <span>{{kmTotal}} / {{timeTotal}}</span>
              </div>
            </div>
            <div class="row wrapper-md"> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
  #map{
    display: flex;
    width: 100%;
    height: 40vh;
  }
  .mapboxgl-control-container{
    display: none;
  }
  .label-info{
    font-size: 16px;
    font-weight: bold;
    color: white;
  }
  @media (max-width: 768px){
    .btn-search{
      margin-top: 10px;
      float: right;
    }
  }

</style>



// WEBPACK FOOTER //
// Solicitar.vue?2ffc573c